var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/_cloneArrayBuffer.js
// module id = ./node_modules/recharts/node_modules/lodash/_cloneArrayBuffer.js
// module chunks = 1